import { ofType, Epic } from "redux-observable";
import { catchError, map, merge, mergeMap, of, takeUntil } from "rxjs";
import { selectAuthTokens } from "../../../../features/auth/selectors/auth.selector";
import { downloadInBrowser } from "../../../../features/download/service/downloader";
import { IAction } from "../../../../interface/action.interface";
import { IErrorDto } from "../../../../interface/dto/error.dto";
import { IRootState } from "../../../../redux/root.reducer";
import { DelimeterType } from "../../../user-preferences/enums/file-delimeter";
import { TerminatorType } from "../../../user-preferences/enums/line-terminator";
import { getUserPreferences } from "../../../user-preferences/services/user-preferences.api";
import { getHistoricalSnapshot } from "../../service/historical-snapshots.api";
import {
    HistoricalSnapshotActionType,
    IHistoricalSnapshotAction,
    historicalSnapshotGetErrorAction,
    historicalSnapshotGetSuccessAction,
    IHistoricalSnapshotGetAction,
} from "./historical-snapshots.actions";

export const historicalSnapshotEpic: Epic<IAction, IAction, IRootState> = (
    action$,
    state$,
) =>
    merge(
        action$.pipe(
            ofType<
                IHistoricalSnapshotAction,
                HistoricalSnapshotActionType.HISTORICAL_SNAPSHOT_GET
            >(HistoricalSnapshotActionType.HISTORICAL_SNAPSHOT_GET),
            mergeMap((action) =>
                getHistoricalSnapshot(
                    action.payload.listId,
                    selectAuthTokens(),
                ).pipe(
                    takeUntil(
                        action$.pipe(
                            ofType<
                                IHistoricalSnapshotGetAction,
                                HistoricalSnapshotActionType.HISTORICAL_SNAPSHOT_GET
                            >(
                                HistoricalSnapshotActionType.HISTORICAL_SNAPSHOT_GET,
                            ),
                        ),
                    ),
                    map((result) =>
                        historicalSnapshotGetSuccessAction(result ?? []),
                    ),
                    catchError((error: IErrorDto) =>
                        of(historicalSnapshotGetErrorAction(error.message)),
                    ),
                ),
            ),
        ),

        action$.pipe(
            ofType(
                HistoricalSnapshotActionType.HISTORICAL_SNAPSHOT_EXPORT_SUMMARY,
            ),
            mergeMap(() => {
                const snapshots =
                    state$.value.listPage.historicalSnapshot.snapshots;
                if (snapshots) {
                    getUserPreferences(selectAuthTokens()).subscribe(
                        (userPreferences) => {
                            const tabDelimiter =
                                userPreferences.fileFormatDelimiter ===
                                DelimeterType.TabDelimeter;
                            const csvContent = [
                                [
                                    "Historical Snapshot Date",
                                    "Number of Locations",
                                    "Countries",
                                    "COVID-19",
                                ],
                                ...snapshots.map((snapshot) => [
                                    snapshot.date,
                                    snapshot.records,
                                    `"${snapshot.country.join(", ")}"`,
                                    snapshot.covid ? "Yes" : "No",
                                ]),
                            ]
                                .map((e) => e.join(tabDelimiter ? "\t" : ","))
                                .join(
                                    userPreferences.fileFormatTerminator ===
                                        TerminatorType.UnixStyle
                                        ? "\n"
                                        : "\r\n",
                                );
                            downloadInBrowser(
                                csvContent,
                                `historical_summary.${tabDelimiter ? "tsv" : "csv"}`,
                            );
                        },
                    );
                }
                return of();
            }),
        ),
    );
